import { Link } from "react-router-dom";
import TopNav from "../components/TopNav.jsx";

export default function PaymentCancelPage() {
  return (
    <div className="min-h-screen bg-sage-bg text-sage-text sage-grain relative">
      <TopNav />
      <div className="mx-auto max-w-3xl px-4 md:px-8 py-16" data-testid="payment-cancel">
        <div className="text-xs uppercase tracking-[0.2em] text-sage-muted mb-2">Membership · cancelled</div>
        <h1 className="text-3xl md:text-4xl font-bold tracking-tighter uppercase text-sage-text mb-6">
          You backed out. Nothing was charged.
        </h1>
        <p className="text-base text-sage-muted leading-relaxed max-w-2xl sage-prose mb-8">
          The checkout was cancelled before payment. No card was charged and nothing lands on the Ledger. If the tier isn't right, browse the two options again below.
        </p>
        <Link
          to="/tiers"
          data-testid="cancel-tiers-link"
          className="text-xs uppercase tracking-[0.1em] border border-sage-accent text-sage-accent px-4 py-2 hover:bg-sage-accent hover:text-sage-bg transition-colors duration-150"
        >
          Back to Membership →
        </Link>
      </div>
    </div>
  );
}
